



















import Vue from "vue";
import "vue-simple-suggest/dist/styles.css";
import { UserProfile } from "@/api/dto/UserProfile";

export default Vue.extend({
  name: "CorporateSideTabs",
  props: {
    current: String,
    modeName: String,
  },
  data() {
    this.$store.commit("setMode", {
      mode: ["notice", "account", "corporate", "payment", "bill"].includes(this.$route.params.modeName)
        ? this.$route.params.modeName
        : "notice",
    });
    return {
      modes: [
        { mode: "notice", text: "通知設定", to: "/corporate/settings/notification", manager: false},
        { mode: "account", text: "アカウント情報", to: "/corporate/settings/account", manager: false },
        { mode: "corporate", text: "法人情報", to: "/corporate/settings/corpInfo", manager: true },
        { mode: "bill", text: "請求明細", to: "/corporate/settings/billingStatement", manager: true },
      ],
    };
  },
  computed: {
    loginData(): UserProfile {
      return this.$store.getters.userProfile;
    },
    isManagementUser(): boolean {
      return this.loginData.corporationsData.isManagementUser
    },
    mode(): string {
      return this.$store.state.mode;
    },
    isDisabled() {
      return true;
    },
  },
  methods: {
    changeMode(key: string) {
      this.$store.commit("setMode", { mode: key });
    },
  },
});
